import { useTranslation } from "react-i18next";
import { useRCAMainStyles } from "../RCA.styles";
import { Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useStyles } from "./RCASettings.styles";
import { ModuleSettingsEnum } from "./RCASettingsInterfaces";
import { RCATriggersSetting } from "./tabs/RCATriggers/RCATriggersSetting";
import { RCAMeetingTypesSetting } from "./tabs/RCAMeetingSetting/RCAMeetingSetting";

const RCASettings = () => {
    const mainClasses = useRCAMainStyles();
    const classes = useStyles();
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(ModuleSettingsEnum.RCA_TRIGGERS);

    const handleTabChange = (event: React.SyntheticEvent, newTab: number) => {
        setActiveTab(newTab);
    };

    const tabsComponents = useMemo(
        () => ({
            [ModuleSettingsEnum.RCA_TRIGGERS]: {
                component: <RCATriggersSetting />,
            },
            [ModuleSettingsEnum.MEETING_TYPES]: {
                component: <RCAMeetingTypesSetting />,
            },
        }),
        [],
    );

    return (
        <div style={{ padding: "30px 22px 0px 22px" }} className={mainClasses.mainWrapper}>
            <Tabs value={activeTab} onChange={handleTabChange} className={classes.tabs}>
                <Tab
                    value={ModuleSettingsEnum.RCA_TRIGGERS}
                    label={
                        <span className={classes.tabTitle}>
                            {t("rca.settings.title")}{" "}
                            <Tooltip
                                PopperProps={{
                                    className: classes.tooltip,
                                }}
                                title={
                                    <div>
                                        <Typography className={classes.tooltipTexts} variant="body2">
                                            {t("rca.settings.info_view_tooltip_content.paragraph_1")}
                                            <ul>
                                                <li>{t("rca.settings.info_view_tooltip_content.duration_trigger")}</li>
                                                <li>{t("rca.settings.info_view_tooltip_content.frequency_trigger")}</li>
                                            </ul>
                                            {t("rca.settings.info_view_tooltip_content.paragraph_2")}
                                        </Typography>
                                    </div>
                                }
                            >
                                <InfoIcon color="info" />
                            </Tooltip>
                        </span>
                    }
                />
                <Tab value={ModuleSettingsEnum.MEETING_TYPES} label={t("rca.settings.meeting_settings.title_tab")} />
            </Tabs>
            {tabsComponents[activeTab].component}
        </div>
    );
};

export default RCASettings;
